app.controller('BrowsePropertyAssemblyController', ['$rootScope', '$scope', function ($rootScope, $scope) {


    let validChoiceIDs = null;
    if ($scope.is_edit_mode) {
        $scope.navigation_ids = $scope.getEditNavigationIDs ? $scope.getEditNavigationIDs() : $scope.navigation_ids;
        validChoiceIDs = $scope.getEditChoiceIDs ? $scope.getEditChoiceIDs() : null;
    }

    $scope.assembly_model = $rootScope.factory.assembly.getModel($scope.navigation_ids);
    $scope.assembly_choice_list = $scope.assembly_model.choiceList();
    if (validChoiceIDs) {
        for (let i = 0; i < $scope.assembly_choice_list.length; i++) {
            const choice = $scope.assembly_choice_list[i];
            if (!validChoiceIDs.includes(choice.id)) {
                $scope.assembly_choice_list.splice(i, 1);
                i--;
            }
        }
    }


}])